import * as React from 'react';

export const MailRu = () => {
  return (
    <>
      <script
        type="text/javascript"
        dangerouslySetInnerHTML={{
          __html:
            'var _tmr = window._tmr || (window._tmr = []);\n' +
            '    _tmr.push({id: "3243342", type: "pageView", start: (new Date()).getTime(), pid: "USER_ID"});\n' +
            '    (function (d, w, id) { if (d.getElementById(id)) return; var ts = d.createElement("script");\n' +
            '        ts.type = "text/javascript";\n' +
            '        ts.async = true; ts.id = id;\n' +
            '        ts.src = "https://top-fwz1.mail.ru/js/code.js"; var f = function () {var s = d.getElementsByTagName("script")[0]; s.parentNode.insertBefore(ts, s);};\n' +
            '        if (w.opera == "[object Opera]") { d.addEventListener("DOMContentLoaded", f, false); } else\n' +
            '        { f(); } })(document, window, "topmailru-code");',
        }}
      ></script>
      <noscript>
        <div>
          {' '}
          <img
            src="https://top-fwz1.mail.ru/counter?id=3243342;js=na"
            style={{ border: 0, position: 'absolute', left: '-9999px' }}
            alt="Top.Mail.Ru"
          />
        </div>
      </noscript>
      <script
        type="text/javascript"
        dangerouslySetInnerHTML={{
          __html:
            '    var _tmr = window._tmr || (window._tmr = []);\n' +
            '    _tmr.push({id: "3279151", type: "pageView", start: (new Date()).getTime()});\n' +
            '    (function (d, w, id) {\n' +
            '        if (d.getElementById(id)) return;\n' +
            '        var ts = d.createElement("script"); ts.type = "text/javascript"; ts.async = true; ts.id = id;\n' +
            '        ts.src = "https://top-fwz1.mail.ru/js/code.js";\n' +
            '        var f = function () {var s = d.getElementsByTagName("script")[0]; s.parentNode.insertBefore(ts, s);};\n' +
            '        if (w.opera == "[object Opera]") { d.addEventListener("DOMContentLoaded", f, false); } else { f(); }\n' +
            '    })(document, window, "tmr-code");',
        }}
      ></script>
      <noscript>
        <div>
          <img
            src="https://top-fwz1.mail.ru/counter?id=3279151;js=na"
            style={{ position: 'absolute', left: '-9999px' }}
            alt="Top.Mail.Ru"
          />
        </div>
      </noscript>
    </>
  );
};
